import { VotingOption } from "../Helpers/VotingSectionHelpers";

type VotingPoolButtonsOptionsProps = {
  options: VotingOption[];
  selectedOptionIds: string[];
  onToggleOption: (optionId: string) => void;
  pollCounts: Record<string, number>;
};

const getBarWidthPercent = (count: number, totalCount: number): number => {
  if (totalCount <= 0 || count <= 0) return 0;
  return (count / totalCount) * 100;
};

export const VotingPoolButtonsOptions = ({
  options,
  selectedOptionIds,
  onToggleOption,
  pollCounts,
}: VotingPoolButtonsOptionsProps) => {
  if (!options.length) return null;

  const counts = options.map((option) => pollCounts[option.id] ?? 0);
  const totalVoteCount = counts.reduce((sum, count) => sum + count, 0);

  return (
    <div className="flex flex-col gap-6">
      {options.map((option) => {
        const description = option.fields?.Description?.value;
        if (!description) return null;

        const voteCount = pollCounts[option.id] ?? 0;
        const isSelected = selectedOptionIds.includes(option.id);
        const barWidth = getBarWidthPercent(voteCount, totalVoteCount);

        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onToggleOption(option.id)}
            aria-pressed={isSelected}
            className={`relative w-full overflow-hidden rounded-xl bg-[#F3F4F6] text-start transition-shadow ${
              isSelected ? "ring-2 ring-primary-600 ring-offset-2" : ""
            }`}
          >
            <div
              className="absolute inset-y-0 start-0 rounded-s-xl bg-[#B8EACB]"
              style={{ width: `${barWidth}%` }}
              aria-hidden="true"
            />
            <div className="relative flex items-center justify-between gap-4 px-5 py-3.5">
              <span className="text-base font-medium text-[#161616]">{description}</span>
              <span className="shrink-0 text-base font-medium text-[#161616]">{voteCount}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};
